import type { TranslationKeysError } from '../localeType';

export const ptPT_error: TranslationKeysError = {
  error: 'Error:',
  // Update ORDER
  ORDER_NOT_FOUND: `Pedido não encontrado`,
  ORDER_SUSPENDED: `O pedido está suspenso`,
  ORDER_IN_USE: `O pedido está em uso`,
  FLORIST_NOT_FOUND: `Código da florista não encontrado`,
  NOTIFICATION_CHANNEL_EMPTY: `Ocorreu um erro no sistema`,
  UPDATE_NOT_ALLOWED_WRONG_STATUS: `O pedido não pode ser alterado para este status`,
  UPDATE_NOT_ALLOWED_WRONG_EXECUTOR: `O usuário não pode modificar o pedido`,
  UPDATE_KO: `O status do pedido foi alterado, mas há um erro relacionado ao faturamento`,
  EXCEPTION: `O pedido não pode ser atualizado. Ocorreu um erro.`,
  UNKNOWN_EXCEPTION: `O pedido não pode ser atualizado. Ocorreu um erro.`,
  OrderNotFoundException: `Pedido não encontrado`,
  IncorrectOrderActionException: `A ação solicitada não é suportada.`,
  OrderStatusNotConsistentException: `O novo status solicitado no pedido não é possível`,
  InvariantException: `Erro técnico no sistema : HTTP BAD REQUEST`,
  // POST ORDER
  IncorrectBodyModelException: `Transmissão falhou: Erro interno - Código de erro: PO-01`,
  IncorrectOrderException: `Transmissão falhou: Erro interno - Código de erro: PO-02`,
  BadRequestException: `Transmissão falhou: Erro interno - Código de erro: PO-03`,
  Exception: `Transmissão falhou: Erro interno - Código de erro: PO-04`,
  FeasabilityExceptionRaoKo: 'Transmissão falhou: Erro interno - Código de erro: PO-05',
  FeasabilityExceptionRaoResponseDataKo: `Transmissão falhou: Erro interno - Código de erro: PO-06`,
  FeasabilityExceptionEmptyFlorists: '`Transmissão falhou: Erro interno - Código de erro: PO-07`',
  PersonalCodeExceptionPersonalCodeNotFound: `Transmissão falhou: Erro interno - Código de erro: PO-08`,
  PersonalCodeExceptionExecutingFloristMismatch: `Transmissão falhou: Erro interno - Código de erro: PO-09`,
  ValidationException: 'Validação do pedido impossível (campos ausentes) - Código de erro: PO-10',
  PersonalCodeNeededPsm: 'Aprovação prévia necessária para produto personalizado (PSM) - Código de erro: PO-11',
  PersonalCodeNeededXProduct:
    'Aprovação prévia necessária para produto com código terminando em X - Código de erro: PO-12',
  PersonalCodeNeededPrice:
    'O preço excede o tamanho extra grande, é necessário um código de aprovação - Código de erro: PO-12',
  PersonalCodeNeededPreparationTime:
    'Aprovação prévia necessária, tempo de preparação muito curto - Código de erro: PO-13',
  PersonalCodeNeededHourLimit:
    'Aprovação prévia necessária, prazo de entrega muito curto para o horário escolhido - Código de erro: PO-14',
  SelectedExecutingFloristNotFound: `Florista executor não encontrado - Código de erro: PO-15`,
  UpdatePersonalCodeKO: 'Impossível atualizar o código AP porque já está em uso.',
  // LOGIN
  loginError: {
    floristUnknown: {
      title: `O login do florista não foi encontrado.`,
      body: `Por favor, clique no botão "Logout".`,
    },
    noCountryCode: {
      title: `O código do país da florista não foi encontrado.`,
      body: 'Por favor, clique no botão "Logout"',
    },
    logoutButton: 'Sair',
  },
};
